import { createSSRApp, createApp } from 'vue';
import App from './App.vue'
// import './registerServiceWorker'
import createRouter from './router'
import createStore from './store'
import { i18n } from './i18n'

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

const isSSR = typeof window === 'undefined';

export default function buildApp() {
  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration
  const firebaseConfig = {
    apiKey: "AIzaSyCHU73viJwBqJsVZcffGo4-HKSwZ1QYuLg",
    authDomain: "zamon.uz",
    // authDomain: "vue-zamon.firebaseapp.com",
    projectId: "vue-zamon",
    storageBucket: "vue-zamon.appspot.com",
    messagingSenderId: "68645814558",
    appId: "1:68645814558:web:232325664031c5ce1a090f"
  };

  // Initialize Firebase
  const firebase = initializeApp(firebaseConfig);

  const app = (isSSR ? createSSRApp(App) : createApp(App));

  const i18nRoute = (to) => {
    return {
      ...to,
      name: `${i18n.global.locale.value || i18n.global.locale}_${to.name}`,
    }
  }
  const staffI18nRoute = (to) => {
    return {
      ...to,
      name: `${i18n.global.locale.value || i18n.global.locale}_${to.name}_StaffDetail`,
    }
  }
  const authI18nRoute = (to) => {
    return {
      ...to,
      name: `${i18n.global.locale.value || i18n.global.locale}_${to.name}_Authorization`,
    }
  }

  app.config.globalProperties.$i18nRoute = i18nRoute
  app.config.globalProperties.$staffI18nRoute = staffI18nRoute
  app.config.globalProperties.$authI18nRoute = authI18nRoute

  app.config.globalProperties.$scrollToTop = (behavior = 'auto') => window?.scrollTo({ top: 0, behavior });

  const router = createRouter();
  const store = createStore();

  app.use(i18n)
  app.use(store)
  app.use(router)
  app.use(firebase)

  return { app, router, store };
}
